import mimir from "helpers/mimir";

const useMimir = () => {    
    return { mimir };
};

export default useMimir;